module.exports = __webpack_public_path__ + "static/image-social-card-e5875f156bfdbadcebded510f98681d2.png";